import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Filters } from '../../../..';
import {
  FilterBarElement,
  FilterBarInputElement,
} from '../filter-bar-element.component';

interface Dictionary<T> {
  [key: string]: T;
}

type SelectedItems<R> = Dictionary<{ id: string; selected?: boolean; data: R }>;

@Component({
  selector: 'rr-search-input-element',
  templateUrl: './search-input-element.component.html',
  styleUrls: ['./search-input-element.component.scss'],
})
export class SearchInputElementComponent<
  F extends Filters,
  K extends keyof F = keyof F,
> implements FilterBarInputElement<string>, AfterViewInit
{
  @Input() items: Dictionary<{ id: string; selected?: boolean; data: string }>;
  @Input() element: FilterBarElement<F, K>;

  @Output() valueChanged: EventEmitter<string> = new EventEmitter();

  @ViewChild('inputText') inputText: ElementRef<HTMLInputElement>;
  @Input() filterValueSub: BehaviorSubject<string>;

  options: { datasource: () => string[] } = { datasource: () => [] };

  filterValue: string = '';
  filteredResults: Array<{
    id: string;
    text: string;
    selected?: boolean;
    data: string;
  }> = [];

  constructor() {}

  setValue(value: string) {
    console.log('setValue:', value);
  }

  ngAfterViewInit(): void {
    if (!this.options) return;

    // get our currently selected options from the filter...
    this.filterValueSub.subscribe((filterValue) => {
      console.log('SearchInputElementComponent', 'subscribe:', filterValue);
      this.filterValue = filterValue;

      this.updateBadge();
      this.filterResults();
    });
  }

  updateBadge() {
    this.element.badge = Object.getOwnPropertyNames(this.items)
      .map((r) => this.items[r].selected)
      .filter((r) => r).length;
  }

  public label: string;

  init(element: FilterBarElement<F, K>) {
    this.element = element as any;

    if ('label' in this.element.config) {
      this.label = this.element.config.label;
    }

    // get all our options that can be selected...
    Promise.resolve(this.options.datasource()).then((data) => {
      if (!data) return;

      this.items = data.reduce((acc, cur) => {
        // const format = this.element.config.format(cur);
        acc[cur] = {
          text: cur,
          value: cur,
          data: cur,
        };
        return acc;
      }, {});
    });
  }

  async filterResults() {
    if (!this.items) return;
    this.filteredResults = Object.getOwnPropertyNames(this.items)
      .map((r) => ({
        ...this.items[r],
        id: r,
        text: `${r}`, // this.element.config.format(this.items[r].data).text,
      }))
      .filter((r) => {
        return r.text.toLowerCase().includes(this.filterValue.toLowerCase());
      })
      .sort((a, b) => {
        if (a.selected && !b.selected) return -1;
        if (!a.selected && b.selected) return 1;
        return 0;
      });
  }

  getValue() {
    return this.filterValue;
  }

  detectChanges(event: Event | KeyboardEvent) {
    if ('key' in event && event.key === 'Escape') {
      console.log((event as KeyboardEvent).key);
      this.inputText.nativeElement.value = '';
    }

    if (
      this.inputText &&
      this.filterValue !== this.inputText.nativeElement.value
    ) {
      this.filterValue = this.inputText?.nativeElement.value;
      this.filterResults();
    }
  }

  toggleResultCheck(id: string, event: Event | MouseEvent) {
    event.stopPropagation();
    if (!this.items[id]) return;

    this.items[id].selected = !this.items[id].selected;
    this.filterResults();
    this.valueChanged.emit(this.getValue());
  }
}
